import React, { useState, useEffect } from 'react';
import CardProfile from '../../../components/Profile/Card/';

//import AboutForm from './Forms';
//import { Formik } from 'formik';
//import { validationContactInfoAbout } from '../../../utils/validations';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import AuthButton from '../../../components/Buttons/AuthButton';
import ButtonAction from '../../../components/Buttons/ButtonAction';
import OptionsButton from '../../../components/Buttons/OptionsButton';
import AddVideo from '../../../components/Profile/AddVideo';
import { makeStyles } from '@material-ui/styles';
import './VideoProf.scss';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Snackbar from './../../../components/Snackbar';

//import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
// import { addVideoYoutube } from '../../../store/actions/UserAction';
import { deleteVideoYoutube } from '../../../store/actions/UserAction';
import { openModalFree } from '../../../store/actions/ModalFree';
import { isMobile } from 'react-device-detect';

import YouTube from 'react-youtube';


const opts = {
  height: '100%',
  width: '100%',
  marginBottom: '0',
  playerVars: {
    autoplay: 0,
  },
};

const _onReady = event => {
  // access to player in all event handlers via event.target
  event.target.pauseVideo();
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 16,
    marginTop: 24,
  },
  title: {
    fontSize: 22,
    color: '#013957',
    borderBottom: 'thin solid #e7e7e7',
    paddingBottom: 8,
    marginBottom: 23,
    width: '100%',
  },
  text: {
    color: '#484848',
    lineHeight: 'normal',
  },
  seeMore: {
    fontWeight: 'bold',
    color: '#10587f',
    lineHeight: 'normal',
    marginRight: 8,
  },
  expandButton: {},
  summaryContent: {
    marginTop: 23,
    alignSelf: 'start',
  },
  addContainer: {
    display: 'flex',
  },
  addSubtitle: {
    color: '#969696',
    fontSize: 12,
    margin: '0 0 0 24px'
  }
}));

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    color: '#484848',
    borderRadius: 4,
    marginTop: 20,
    display: 'grid',
    '&::before': {
      height: 0
    }
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    flexFlow: 'column',
    padding: 0,
    //minHeight: 56,
    position: 'relative',
  },
  content: {
    margin: 0,
    width: '100%',
    //flexFlow: 'column',
    alignItems: 'center',
    padding: '0 0 16px',
    '&$expanded': {
      margin: 0,
    },
  },
  expandIcon: {
    color: '#013957',
  },

  expanded: {
    margin:0
  },
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    padding: isMobile ? 0 : '0 24px',
    display: 'block',
  },
})(MuiExpansionPanelDetails);

const VideoProf = (props) => {
  const {
    uid,
    videosYoutube,
    deleteVideoYoutube,
    authClient,
    membershipType,
    openModalFree
  } = props
  const [elements, setElements] = useState([])
  const [btnAddEstaActivo, setBtnAddEstaActivo] = useState('t1_enable')
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success'
  });

  /*  {
        id: 1,
        pathImg: 'https://via.placeholder.com/232x128/0000FF/808080',
      },
      {
        id: 2,
        pathImg: 'https://via.placeholder.com/232x128/00BB/808080',
      },
  ]); */

  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    setSubmitting(false);
  };

  const formValues = {
    specialties: [],
  };

  const classes = useStyles();

  let membershipLimit = 7

  const [expanded, setExpanded] = useState(false);

  const handleChange = panel => (event, isExpanded) => {
    if (elements.length >= membershipLimit) {
      setExpanded(false)
      setBtnAddEstaActivo('t1_disabled')
    } else {
      setExpanded(isExpanded ? panel : false);
    }
  };

  const changeStatus = isActive => {
    setExpanded(isActive ? true : false)
  }

  const btnAddChangeStatus = () => {
    const limit = membershipLimit + 1
    if (elements.length > limit) {
      setBtnAddEstaActivo('t1_disabled')
    } else {
      setBtnAddEstaActivo('t1_enable')
    }

  }

  // btnAddEstaActivo

  const addVideo = urlVideo => {
    let nElements = elements.length + 1;    
    elements.push(
      {
        id: nElements,
        youtube: urlVideo,
      }
    )
    btnAddChangeStatus()
    setElements(elements)
    //videosYoutube && videosYoutube ? (setElements(...videosYoutube)) : (setElements(elements))
  }

  useEffect(() => {
    let newItem = [];
    if (videosYoutube && videosYoutube.length ) {
      videosYoutube.map((item, index) => (
        newItem.push(
          {
            id: index,
            youtube: item.youtube,
          }
        )
      ))
      setElements(newItem)
    }
  }, []);


  function YouTubeGetID(item){
    var videoid = item.youtube.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    if (videoid != null) {
      return videoid[1]
    }
  }

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success'
    });
  };
  const handleSnack = () => {
    setFeedbackMessage({
      open: true,
      message: 'Tus cambios se han guardado con éxito',
      variant: 'success'
    });
  }

  const handleDelete = (idImage, arr) => {
    var newVideoElem = elements.filter(function (item) {
      return item.id !== idImage;
    });
    
    let boolValues
    if (elements.length <= 1 || !elements.length) {
      boolValues = false
    } else {
      boolValues = true
    }

    setElements(newVideoElem);
    deleteVideoYoutube(newVideoElem, uid, idImage, boolValues).then(res => {
      setFeedbackMessage({
        open: true,
        message: 'El video se ha borrado con éxito',
        variant: 'success'
      });
      setExpanded(false)
      //setLoadingFormData(false) 
    }).catch(error => {})
  };

  return (
    <>
      <div className={'videoProf'}>
        <CardProfile
          title={'Videos informativos'}
          subTitle={
            `Puedes adjuntar hasta ${membershipLimit} ligas de tus videos informativos previamente cargados en YouTube.`
          }
          awardIcon
          status={authClient && authClient.awardAditional.videos ? authClient.awardAditional.videos : false}
        >
          <ExpansionPanel
            expanded={expanded === 'panel1'}
            onChange={expanded === false &&
              handleChange('panel1')
            }
          >

            <ExpansionPanelSummary aria-controls="panel2a-content">
              <div
                className={classes.expandButton}
                style={{
                  opacity: expanded === false ? 'initial' : 0.5,
                  cursor: expanded === false ? 'pointer' : 'not-allowed',
                }}
              >
                <div className={classes.addContainer}>
                  <img className="plus" src="../img/profile/plus.svg" alt="" />
                  <p
                    className={btnAddEstaActivo}
                    style={{ margin: 'auto 0' }}
                  >
                    Añadir video
                  </p>
                </div>
                {/* {membershipType === 'Free' ?
                  <div className={classes.addSubtitle}>
                    Disponible solo para usuarios Premium y Premium Plus
                  </div> : null
                } */}
              </div>

            </ExpansionPanelSummary>

            <ExpansionPanelDetails>

              <AddVideo evento={changeStatus} e_target={addVideo} snack={handleSnack} elements={elements} />

            </ExpansionPanelDetails>
          </ExpansionPanel>
          <div className="PictureProfile">

            {elements.map((item, index, arr) => (
              <div key={index}
                className="Picture-1"
                onClick={() => {
                  changeStatus(item.id);
                }}
              >
                <YouTube
                  key={index}
                  videoId={YouTubeGetID(item)}
                  opts={opts}
                  onReady={_onReady}
                />
                <div className="AddPicture" >
                  <img src="/img/profile/trash.svg" alt='trash' onClick={() => { handleDelete(item.id, arr); }} />
                </div>
                {/* 
                    <div >
                      <DeleteForeverIcon
                        onClick={() => {
                          handleDelete(item.id);
                        }}
                      />
                   */}
              </div>
            ))}
          </div>
        </CardProfile >
       
      </div>
      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '60px' : '80px'}
      />
    </>
  );
};

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  authClient: state.authClient,
  videosYoutube: state.authClient.videosYoutube,
  membershipType: state.authClient.membership.type,
});

const mapDispatchToProps = dispatch => ({
  deleteVideoYoutube: (values, uid, indexVideo, boolValues) => dispatch(deleteVideoYoutube(values, uid, indexVideo, boolValues)),
  openModalFree: (open, typeMembership, role) => dispatch(openModalFree(open, typeMembership, role))
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoProf);